import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		height: "100%",
		minHeight: 0,
		overflow: "hidden",
	},

	contentWrapper: {
		padding: theme.spacing(2),
		paddingLeft: "1% !important",
		paddingRight: "1% !important",
		[theme.breakpoints.down('sm')]: {
			paddingLeft: "16px !important",
			paddingRight: "16px !important",
		},
		flex: 1,
		height: "100%",
		minHeight: 0,
		boxSizing: "border-box",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
